import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { EcosystemClassificationType } from '@/api/rest/resources/types/ecosystemClassification';
import { METHODOLOGY_EXPLAINER_PAGE_ECOSYSTEM_CLASSIFICATION } from '@/config/constants';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

export const EcosystemClassificationExplainer = ({ category }: { category: EcosystemClassificationType }) => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='ecosystem-classification-explainer'>
        {t('shared.ncaDetail.details.labels.howDoWeMeasureThis')}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>
          {t(`shared.ncaDetail.ecosystemClassification.${category}.explainers.howDoMeasureThis.headline`)}
        </ExplainerTitle>
        <Stack className='items-start pb-6'>
          <ExplainerBody>
            <ExplainerCopy
              body={t(`shared.ncaDetail.ecosystemClassification.${category}.explainers.howDoMeasureThis.body`)}
            />
          </ExplainerBody>
          <MethodologyLink to={METHODOLOGY_EXPLAINER_PAGE_ECOSYSTEM_CLASSIFICATION} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
